export default __webpack_public_path__ + "5f6178a84c13e9c2361a35b1a57e14ef.png";